export const CLOSE_ICON_PADDING = 12;
export const CLOSE_ICON_SIZE = 24;

export const BOTTOM_GLOW_EXTRA_WIDTH = 86;
export const BOTTOM_GLOW_HEIGHT = 280;
export const BOTTOM_GLOW_OFFSET = 48;
export const BOTTOM_GLOW_BLUR_VALUE = 50;
export const TOP_GLOW_BLUR_VALUE = 100;
export const TOP_GLOW_RADIUS = 200;
export const TOP_GLOW_COLOR_OPACITY = 0.4;
export const TOP_GLOW_CIRCLE_X = 0;
export const TOP_GLOW_CIRCLE_Y = 0;
